import React from 'react';
import './Testimonial.scss';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import imgOne from '../../assets/testimonial/1.png';
import imgTwo from '../../assets/testimonial/2.png';
import imgThree from '../../assets/testimonial/3.png';
import TestimoniCard from '../../components/TestimoniCard/TestimoniCard';
import { AiFillStar } from "react-icons/ai";
import Slider from "react-slick";

const Testimonial = () => {

    const testimonails = [
        {
            'img': imgOne,
            'name': 'Eulene Scrinmger',
            'description' : 'Fui muito bem atendida desde a recepção até ao final do tratamento. A equipa é extremamente profissional, atenciosa e faz-nos sentir completamente à vontade. Recomendo sem hesitar',
            'ratings':[<AiFillStar/>,<AiFillStar/>,<AiFillStar/>,<AiFillStar/>,<AiFillStar/>]
        },
        {
            'img': imgTwo,
            'name': 'Alberto Flores',
            'description' : 'Excelente experiência. O atendimento foi rápido, claro e muito humano. Explicaram-me todo o procedimento e senti-me seguro durante todo o processo',
            'ratings':[<AiFillStar/>,<AiFillStar/>,<AiFillStar/>,<AiFillStar/>,<AiFillStar/>]
        },
        {
            'img': imgThree,
            'name': 'Bernanda Carlos',
            'description' : 'Gostei muito do cuidado e da atenção aos detalhes. O ambiente é agradável e transmite muita confiança. Sem dúvida voltarei sempre que precisar',
            'ratings':[<AiFillStar/>,<AiFillStar/>,<AiFillStar/>,<AiFillStar/>,<AiFillStar/>]
        },
        {
            'img': imgOne,
            'name': 'Gustavo Morais',
            'description' : 'Serviço de alta qualidade, profissionais competentes e muito simpáticos. O resultado superou as minhas expectativas. Fiquei muito satisfeito com o atendimento.',
            'ratings':[<AiFillStar/>,<AiFillStar/>,<AiFillStar/>,<AiFillStar/>,<AiFillStar/>]
        }
    ]

    // slider
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
                initialSlide: 2
              }
            },
            {
              breakpoint: 575,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
        ]
    };

    return (
        <section className='testimonail-section section-bg section-common pt-100 pb-70' data-aos="fade-up" data-aos-duration="2000">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                        <SectionTitle 
                        subTitle="TESTIMONIAL"
                        title="O que as pessoas disseram sobre nós"
                        />
                    </div>
                    <div className="col-lg-6">
                        <p className="pt-5">Veja como nossos pacientes se sentiram ao receber cuidados odontológicos de qualidade. Cada depoimento reflete nossa dedicação em oferecer um atendimento gentil, seguro e personalizado, garantindo sorrisos saudáveis e confiantes.</p>
                    </div>
                </div>

                <Slider {...settings} className="testimoni-slider">
                    {
                        testimonails.map(testimonail => <TestimoniCard testimonail={testimonail} />)
                    }
                </Slider>
               
            </div>
        </section>
    );
};

export default Testimonial;